import { LearnwareInstance } from '../../../learnware/LearnwareEnums';
export class BrowserLocation {
    parent;
    constructor(parent) {
        this.parent = parent;
    }
    get browserRuntime() {
        return this.parent;
    }
    get addressBar() {
        return this.browserRuntime.browserAddressBar;
    }
    get instance() {
        if (this.addressBar.hostnameWithoutSubdomain === 'schlaukopf.ch')
            return LearnwareInstance.AbfragerCH;
        if (this.addressBar.hostnameWithoutSubdomain === 'schlaukopf.at')
            return LearnwareInstance.AbfragerAT;
        return LearnwareInstance.AbfragerDE;
    }
    get pathURI() {
        return this.instance + decodeURIComponent(this.addressBar.locationSnapshot.pathname);
    }
    set pathURI(pathURI) {
        /*  const [instance, ...pathnameParts] = pathURI.split('/');
        const pathname = '/' + pathnameParts.join('/');
        // this.instance = instance;
        if (window.location.pathname !== pathname) {
          window.history.pushState({ page: pathname }, pathname, pathname);
          this.browserLocationChangedHandler();
        } */
    }
}
